import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../../components/Motion";
import ShopCard, { ShopsEmpty } from "../../components/ShopCard";
import ShopsMap from "../../components/ShopsMap";
import { useShops } from "../../lib/useShops";

export default function ShopsSection() {
  const shops = useShops();
  const list = shops ?? [];
  return (
    <section data-testid="home-shops" className="bg-white py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="eyebrow text-brand">Visit us</p>
            <h2 data-testid="home-shops-heading" className="mt-4 font-display text-4xl md:text-6xl font-extrabold uppercase leading-[0.92] text-navy">Our shop locations <span className="text-brand">–</span> <span className="block md:inline">MHM Super AdBlue</span></h2>
          </div>
          <Link to="/locations" data-testid="home-shops-view-all" className="group inline-flex items-center gap-2 font-semibold text-navy hover:text-brand">
            View all shops <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </Reveal>
        {list.some((s) => typeof s.lat === "number") && (
          <Reveal className="mt-12"><ShopsMap shops={list} height="h-[340px] md:h-[420px]" /></Reveal>
        )}
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {list.slice(0, 6).map((s, i) => <ShopCard key={s.id} s={s} index={i} />)}
        </div>
        {shops && list.length === 0 && <div className="mt-10"><ShopsEmpty /></div>}
      </div>
    </section>
  );
}
